import i18n from '../../locales/index'
import restful from '../vuex'
import axios from 'axios'

const state = {
  ...restful.states('mall_category'),
  all_categories: []
}

const getters = {
  ...restful.getters('mall_category'),
  all_categories: (state) => state.all_categories
}

const actions = {
  ...restful.actions('mall_categories'),
  async allCategory ({ commit }) {
    const res = await axios.get('mall_categories?per=10000')
    commit('all_categories', res.data)
  }
}

const mutations = {
  ...restful.mutations('mall_category'),
  all_categories (state, all_categories) {
    state.all_categories = all_categories
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
